import { NgStyle } from '@angular/common';
import { Component, input } from '@angular/core';
import { Dict, RISK_COLOR } from '@nk/utils-lib';

@Component({
  selector: 'nk-risk-level-icon',
  imports: [NgStyle],
  templateUrl: './risk-level-icon.component.html',
})
export class RiskLevelIconComponent {
  public riskLevel = input.required<string>();
  public fixedWidth = input(false);
  public disabled = input(false);
  public riskColors: Dict<string> = RISK_COLOR;
  public disabledItemColor = '#D3D3D3';
}
